module.exports = __webpack_public_path__ + "static/media/user2.06ee5187.webp";